var HomeWorkShowModule = (function () {
    function HomeWorkShowModule() {
    }
    return HomeWorkShowModule;
}());
export { HomeWorkShowModule };



// WEBPACK FOOTER //
// ./src/app/app-home-work-show/home-work-show.module.ts.pre-build-optimizer.js